import React, {useState, useEffect} from 'react';
import {Layout, notification as Notification} from 'antd';
import AppSidebar from './AppSidebar';
import AppHeader from './AppHeader';
import './index.style.less';
import {AppContentView} from '../../../index';
import AppFooter from '../components/AppFooter';
import AppScrollbar from '../../AppScrollbar';
import clsx from 'clsx';
import {FooterType} from '../../../../shared/constants/AppEnums';
import {useLayoutContext} from '../../../utility/AppContextProvider/LayoutContextProvider';
import Logout from '../../../../pages/auth/logout';
import {
  getToken,
  onMessageListener,
} from '../../../../shared/notifications/firebaseinit';
import {useLocalStorage} from '../../../../shared/hooks/useLocalStorage';
import {FCM_TOKEN_KEY} from '../../../../shared/constants/AppConst';
import NotificationsUtils from '../../AppNotifications/utils';

const MiniSidebarToggle = () => {
  const [isCollapsed, setCollapsed] = useState(false);
  const {footer, footerType}: any = useLayoutContext();
  const [storedFCMToken, setStoredFCMToken] = useLocalStorage(FCM_TOKEN_KEY);

  const onToggleSidebar = () => {
    setCollapsed(!isCollapsed);
  };

  useEffect(() => {
    let FCMToken;
    async function tokenFunc() {
      FCMToken = await getToken();
      return FCMToken;
    }
    tokenFunc().then((FCMToken) => {
      if (storedFCMToken !== FCMToken) setStoredFCMToken(FCMToken);
    });
  }, []);

  onMessageListener().then((payload: any) => {
    Notification['info']({
      message: payload?.notification?.title,
      description: payload?.notification?.body,
      onClick: () => NotificationsUtils.handleNotification(payload),
      duration: 15,
    });
  });

  return (
    <Layout
      className={clsx('app-layout-mini-sidebar', {
        appMainFooter: footer && footerType === FooterType.FLUID,
        appMainFixedFooter: footer && footerType === FooterType.FIXED,
      })}>
      <AppSidebar isCollapsed={isCollapsed} />
      <Layout className='app-layout-mini-sidebar-main'>
        <AppHeader
          isCollapsed={isCollapsed}
          onToggleSidebar={onToggleSidebar}
        />
        <AppScrollbar className='main-mini-sidebar-scrollbar'>
          <AppContentView />
          <AppFooter />
          <Logout />
        </AppScrollbar>
      </Layout>
    </Layout>
  );
};

export default MiniSidebarToggle;
